import React, {Component, createElement} from 'react';
import PropTypes from 'prop-types';
import {FormInput} from '@homeaway/react-form-components';
import {LoadingOverlay} from '@homeaway/react-loading-overlay';
import './EmailForm.less';

class EmailForm extends Component {
    static propTypes = {
        brandName: PropTypes.string,
        email: PropTypes.string,
        labels: PropTypes.shape({
            buttonText: PropTypes.string,
            errorMessage: PropTypes.string,
            heading: PropTypes.string,
            inputPlaceholder: PropTypes.string,
            legalNotice: PropTypes.string,
            privacyPolicy: PropTypes.string,
            subheading: PropTypes.string,
            termsAndConditions: PropTypes.string,
        }),
        onValidForm: PropTypes.func,
        privacyPolicyUrl: PropTypes.string,
        termsAndConditionsUrl: PropTypes.string,
    };

    constructor(props) {
        super(props);

        this.state = {
            errorMessage: null,
            inputValue: props.email,
            submitting: false,
        };
        this.inputRef = React.createRef();
    }

    isValidInput = () => {
        const inputValidity = this.inputRef.current.input.validity;
        return !(inputValidity.valueMissing || inputValidity.typeMismatch);
    };

    handleSubmit = (e) => {
        const {
            labels: {errorMessage},
            onValidForm,
        } = this.props;
        const {inputValue} = this.state;

        e.preventDefault();
        e.stopPropagation();

        if (this.isValidInput()) {
            this.setState({errorMessage: null, submitting: true}, () =>
                onValidForm(inputValue)
            );
        } else {
            this.setState({errorMessage, submitting: false});
        }
    };

    handleEmailChange = (e) => {
        this.setState({inputValue: e.target.value});
    };

    renderLegalNotice() {
        const {
            labels: {legalNotice, privacyPolicy, termsAndConditions},
            privacyPolicyUrl,
            termsAndConditionsUrl,
        } = this.props;
        const elements = {
            '{privacyPolicy}': (
                <a href={privacyPolicyUrl} target="_blank">
                    {privacyPolicy}
                </a>
            ),
            '{termsAndConditions}': (
                <a href={termsAndConditionsUrl} target="_blank">
                    {termsAndConditions}
                </a>
            ),
        };
        const tokenDelimiter = '_@_';
        const tokenizedLegalNoticeLabel = legalNotice.replace(
            /\{[^\}]+\}/g,
            `${tokenDelimiter}$&${tokenDelimiter}`
        );
        const nodes = tokenizedLegalNoticeLabel
            .split(tokenDelimiter)
            .map((part) => elements[part] || part);

        return createElement(
            'p',
            {className: 'EmailForm__legalNotice'},
            ...nodes
        );
    }

    renderHeading() {
        const {
            brandName,
            labels: {heading},
        } = this.props;
        return heading.replace('{brandName}', brandName);
    }

    render() {
        const {
            labels: {subheading, inputPlaceholder, buttonText},
        } = this.props;
        const {errorMessage, inputValue, submitting} = this.state;

        return (
            <div className="EmailForm">
                <h2 className="EmailForm__heading">{this.renderHeading()}</h2>
                <p className="EmailForm__subheading">{subheading}</p>
                <form onSubmit={this.handleSubmit} className="EmailForm__form">
                    <div className="EmailForm__fields">
                        <FormInput
                            ref={this.inputRef}
                            id="email-input-form"
                            type="email"
                            label={inputPlaceholder}
                            onChange={this.handleEmailChange}
                            value={inputValue}
                            inverse
                            errorMsg={errorMessage}
                            required
                        />
                        <button
                            type="submit"
                            className="btn btn-primary EmailForm__submit"
                            disabled={submitting}
                            onClick={this.handleSubmit}
                        >
                            {submitting && <LoadingOverlay />}
                            {buttonText}
                        </button>
                    </div>
                    {this.renderLegalNotice()}
                </form>
            </div>
        );
    }
}

export default EmailForm;
